import { Link, useLocation } from "react-router-dom";

// Entrance, Hall and legal documents keep their own navigation.
export function showPlatformLegalFooter(pathname) {
  return pathname !== "/" && pathname !== "/hall" &&
    !pathname.startsWith("/legal") &&
    !(pathname === "/master-order" || pathname.startsWith("/master-order/"));
}


// Each space has its own full-height surface and the shared footer lives
// *after* the route. Transparent therefore inherits the global body rather
// than the page, creating an unwanted pale/dark band. Match the actual
// approved bottom surface of each existing space instead.
export function platformLegalFooterSurface(pathname) {
  if (/^\/(checkout|payment)(\/|$)/.test(pathname)) return "#21150D";
  if (pathname === "/professional-map") return "#F1E5D1";
  if (pathname.startsWith("/professional-map/discover") ||
      pathname.startsWith("/professional-map/profiles/") ||
      pathname.startsWith("/professional-map/questions")) return "#F7F0E5";
  if (pathname.startsWith("/professional-map/")) return "#F2E6D4";
  if (pathname.startsWith("/master-order-testing")) return "#EFE6D5";
  if (pathname.startsWith("/master-order")) return "#F7F1E7";
  if (pathname.startsWith("/brand-studio")) return "#F6F1E9";
  if (pathname.startsWith("/order/")) return "#FBF5EA";
  if (pathname.startsWith("/book/")) return "#F4EBDD";
  if (pathname.startsWith("/gingerbread")) return "#F5E1BF";
  if (pathname.startsWith("/programs/")) return "#EFDFC1";
  // The photographic Programs landing has no solid footer-adjacent surface;
  // use the same warm family as its individual program pages.
  if (pathname === "/programs") return "#EFDFC1";
  return "#FAF7F2"; // existing global cream: library, account, admin, auth
}

export const currentCopyrightYear = (now = new Date()) => now.getFullYear();

export default function PublicLegalFooter({ embedded = false }) {
  const { pathname } = useLocation();
  if (!embedded && !showPlatformLegalFooter(pathname)) return null;
  const isDark = /^\/(checkout|payment)(\/|$)/.test(pathname);

  return (
    <footer
      className="relative z-10 shrink-0 px-4 py-3 sm:px-6"
      style={{ backgroundColor: platformLegalFooterSurface(pathname), color: isDark ? "#F5EAD8" : "#6A5645" }}
      data-testid="public-legal-footer"
    >
      <div className="mx-auto flex w-full max-w-[1180px] flex-wrap items-center justify-center gap-x-6 gap-y-3">
        <div className="flex shrink-0 items-center gap-2">
          <img src="/favicon-48x48.png" alt="" aria-hidden="true"
            width={16} height={16} className="block h-4 w-4 object-contain" />
          <span className={`text-[10px] font-normal tracking-[0.02em] ${isDark ? "text-[#F5EAD8]" : "text-[#4A3528]"}`}>ANOKINA STUDIO</span>
          <span className={`text-[10px] ${isDark ? "text-[#DFCAA9]" : "text-[#8D765F]"}`} data-testid="legal-footer-year">© {currentCopyrightYear()}</span>
        </div>
        <nav aria-label="Юридические документы"
          className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-center text-[11px] leading-5">
          <Link to="/legal" className="hover:underline focus-visible:underline">Правовой центр</Link>
          <Link to="/legal/offer" className="hover:underline focus-visible:underline">Публичная оферта</Link>
          <Link to="/legal/privacy" className="hover:underline focus-visible:underline">Политика конфиденциальности</Link>
        </nav>
      </div>
    </footer>
  );
}
